import httpService from "./httpService";
import utils from "./utils";

export default {
  findById(id) {
    return httpService.get("vbFlowInstance/" + id);
  },

  findAll(example, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(example, pageable);
    return httpService.get("vbFlowInstance", {params: params});
  },

  findCurrentOutgoingDocFlowInstance(docId) {
    return httpService.get("vbFlowInstance/findCurrentOutgoingDocFlowInstance", {params: {docId: docId}});
  }
};



// WEBPACK FOOTER //
// ./src/services/vbFlowInstanceService.js